import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const getNewGamesService = async provider => {
  return privateRequest.get(`${ConfEnv.API_GAMES.NEWEST}${provider ? `?provider=${provider}` : ""}`);
};
